import { ConstructionSiteRequest } from './construction-site';

/** Editable fields of the construction-site form. Every field is a trimmed string
 *  ('' = empty) so the form can diff a value against its loaded original. */
export type ConstructionSiteFormValue = {
  [K in keyof Required<ConstructionSiteRequest>]: string;
};

export const EMPTY_CONSTRUCTION_SITE_FORM_VALUE: ConstructionSiteFormValue = {
  salutation: '',
  name1: '',
  name2: '',
  name3: '',
  name: '',
  street: '',
  streetNumber: '',
  countryCode: '',
  postCode: '',
  city: '',
  poBox: '',
  telephoneNumber: '',
  fax: '',
  mail1: '',
  clerk1: '',
  clerk2: '',
  clerk3: '',
  costCenter: '',
  federalOrderReference: '',
  vatId: '',
  deletionDate: '',
  bankId: '',
  bankAccount: '',
  representativeId: '',
  deliveryHint: '',
  customerDeliveryHint: '',
};

export const CONSTRUCTION_SITE_FORM_FIELDS = Object.keys(
  EMPTY_CONSTRUCTION_SITE_FORM_VALUE
) as (keyof ConstructionSiteFormValue)[];
